import { global } from "../constants";

export const data = {
    banner: {
        background: global.banner + "service1.png",
        // title: "Services Detail",
        crumb: "Services"
    }
}